const AboutTeamImages = () => {
  return (
    <div className="flex flex-col  w-full max-w-[825px] mx-auto">
      <div className="flex ">
        <div className="flex flex-col items-center m  xl:gap-0 md:gap-2 gap-1 w-full self-center xl:self-end">
          <div className="bg-[#433CAE] xl:translate-y-10  xl:self-end flex items-center justify-center text-white font-bold  text-xs md:text-base h-8 md:h-[68px] w-full max-w-[91px] md:max-w-[155px] rounded-full">
            Skilled
          </div>
          <div className="bg-[#00E4FF]  xl:translate-y-8 xl:-translate-x-4 xl:rotate-[20deg] xl:self-end flex items-center justify-center text-[#221E57] font-bold text-xs md:text-base h-8 md:h-[68px] w-full max-w-[161px] md:max-w-[273px] rounded-full">
            10+ Years Together
          </div>
          <div className="  bg-[#433CAE] xl:self-start flex items-center justify-center text-white font-bold text-xs md:text-base h-8 md:h-[68px] w-full max-w-[143px] md:max-w-[200px] rounded-full">
            Quality + Security
          </div>
        </div>
        <img
          className="self-end w-1/2 xl:w-full"
          src="/team/work-space-2.png"
          alt="work space 2"
        />
      </div>
      <div className="flex items-center">
        <img
          className="self-start w-1/2 xl:w-full"
          src="/team/work-space-1.png"
          alt="work space 1"
        />
        <div className=" flex justify-center w-full">
          <img
            className="self-start w-[56px] md:w-fit"
            src="/team/snowIcon.svg"
            alt="work space 1"
          />
        </div>
      </div>
    </div>
  );
};

export default AboutTeamImages;
